//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'TIMI_NSTEMI',
  data() {
    return {
      defaultJson: {
        "Age ≥ 65 years": "年龄 ≥ 65 岁",
        "Known CAD (≥ 50% stenosis)": "既往冠心病史（狭窄 ≥ 50%）",
        "ST deviation ≥ 0.5 mm": "ST段改变≥ 0.5mm",
        "Severe angina in last 24 hrs": "严重心绞痛(24小时内≥2次)",
        "≥ 3 CAD risk factors": "≥ 3 个冠心病危险因素(高血压、糖尿病、冠心病家族史、高脂血症、吸烟)",
        "Aspirin use in the past 7 days": "过去 7 天内服用过阿司匹林",
        "Elevated cardiac markers": "心脏标志物升高"
      },
      form: {
        ageOver65: '0',
        riskFactors: '0',
        knownCAD: '0',
        aspirinUse: '0',
        severeAngina: '0',
        elevatedEnzymes: '0',
        stDeviation: '0'
      },
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    prent() {
      if (this.score < 1) {
        return 0
      } else if (this.score < 2) {
        return 5
      } else if (this.score < 3) {
        return 8
      } else if (this.score < 4) {
        return 13
      } else if (this.score < 5) {
        return 20
      } else if (this.score < 6) {
        return 26
      } else {
        return 41
      }
    },
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      // ageOver65 + riskFactors + knownCAD + clinic + duration
      let result = form.ageOver65 + form.riskFactors + form.knownCAD + form.aspirinUse + form.severeAngina + form.elevatedEnzymes + form.stDeviation

      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/TIMI_NSTEMI.vue